import React, { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { actions as macheteActions } from 'src/machete-redux';
import appDux from 'src/redux/app';

// If you're not sure what portals are - https://reactjs.org/docs/portals.html
const MacheteViewerPortal: React.FunctionComponent = (props) => {
  const rootElemRef = useRef(document.createElement('div'));
  const activeMode = useSelector(appDux.selectors.getActiveMode);
  const isScreenshotModeActive = useSelector(
    appDux.selectors.getIsScreenshotModeActive,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    const parentElem = document.getElementById('machete-root');

    if (!parentElem) {
      return;
    }

    parentElem.appendChild(rootElemRef.current);
    dispatch(macheteActions.viewer.resize());

    return function removeElement() {
      rootElemRef.current.remove();
    };
  }, [activeMode, isScreenshotModeActive]);

  return ReactDOM.createPortal(props.children, rootElemRef.current);
};

export default MacheteViewerPortal;
